<script>
  import { createEventDispatcher } from 'svelte';

  export let keyItems;
  export let row;

  const dispatch = createEventDispatcher();

  function handleClick() {
    dispatch('openModal');
  }

</script>

<button 
on:click="{handleClick}" 
class="report-button" 
aria-label="view full report">
  <img 
  src={ keyItems[row.finding].imgUrl } alt="{ keyItems[row.finding].description}" 
  id={keyItems[row.finding].imgId} 
  />
</button>